import { createTypes } from "../../utils/helpers";

const MENU_ITEMS_FETCH_PRODUCT_PROFILES: any = createTypes(
  'MENU_ITEMS_FETCH_PRODUCT_PROFILES',
);

const MENU_ITEMS_CREATE_PRODUCT_PROFILES: any = createTypes(
  'MENU_ITEMS_CREATE_PRODUCT_PROFILES',
);
const MENU_ITEMS_UPDATE_PRODUCT_PROFILES: any = createTypes(
  'MENU_ITEMS_UPDATE_PRODUCT_PROFILES',
);
const MENU_ITEMS_REMOVE_PRODUCT_PROFILES: any = createTypes(
  'MENU_ITEMS_REMOVE_PRODUCT_PROFILES',
);
const MENU_ITEM_TRANSLATIONS:any = createTypes('MENU_ITEM_TRANSLATIONS');
const MENU_ITEM_TRANSLATIONS_UPDATE:any = createTypes('MENU_ITEM_TRANSLATIONS_UPDATE');
export {
  MENU_ITEMS_FETCH_PRODUCT_PROFILES,
  MENU_ITEMS_UPDATE_PRODUCT_PROFILES,
  MENU_ITEMS_CREATE_PRODUCT_PROFILES,
  MENU_ITEMS_REMOVE_PRODUCT_PROFILES,
  MENU_ITEM_TRANSLATIONS,
  MENU_ITEM_TRANSLATIONS_UPDATE,
};
